import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SidebarMenuButton } from '@/components/ui/sidebar';

import { useChangeLocaleMutation } from '@/mutations';

import { LOCALES_LIST } from '@/constants';

export const SidebarLocaleItem = (props: { url: string }) => {
  const { url } = props;
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language;
  const { mutate: changeLocale, isPending } = useChangeLocaleMutation();

  const onLocaleChange = (locale: string) => {
    if (locale === currentLocale) {
      return;
    }

    changeLocale(
      { url, locale },
      {
        onSuccess: () => {
          window.location.reload();
        },
      },
    );
  };

  return (
    <DropdownMenu>
      <SidebarMenuButton
        asChild
        tooltip={`${t('Language')}: ${currentLocale.toUpperCase()}`}
        className="aria-[haspopup=menu]:after:hidden"
      >
        <DropdownMenuTrigger disabled={isPending}>
          <Languages />
          <span>{t('Language')}</span>
          <span className="ml-auto text-xs uppercase">{currentLocale}</span>
        </DropdownMenuTrigger>
      </SidebarMenuButton>
      <DropdownMenuContent
        side="right"
        align="end"
        collisionPadding={8}
      >
        {LOCALES_LIST.map((locale) => (
          <DropdownMenuItem
            key={locale}
            className="cursor-pointer uppercase"
            onClick={() => onLocaleChange(locale)}
          >
            {locale}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
